import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { useFieldArray, useForm } from 'react-hook-form'
import * as yup from 'yup'
import OperacaoFiscalService from 'business/cadastro/fiscal/operacaoFiscal/operacaoFiscalService'
import ControllerInput from 'base/ControllerInput'
import GridForm from 'base/GridForm'
import { yupResolver } from '@hookform/resolvers/yup'
import FormCadastro, { FormCadastroAux } from 'base/FormCadastro'
import { TabView, TabPanel } from 'primereact/tabview'
import { cd, createCodeDescriptionObject, formatDatetime } from 'helper/formater'
import { defaultEmptySelection } from 'helper/default'
import { errorToToast } from 'helper/error'

import RegimeTributacaoService from 'business/cadastro/fiscal/regimeTributacao/regimeTributacaoService'
import TipoOperacaoFiscalService from 'business/cadastro/fiscal/tipoOperacaoFiscal/tipoOperacaoFiscalService'
import FinalidadeOperacaoFiscalService from 'business/cadastro/fiscal/finalidadeOperacaoFiscal/finalidadeOperacaoFiscalService'
import UfService from 'business/cadastro/pessoa/uf/ufService'
import MunicipioService from 'business/cadastro/pessoa/municipio/municipioService'
import SerieService from 'business/cadastro/fiscal/serie/serieService'
import ModeloDocFiscalService from 'business/cadastro/fiscal/modeloDocFiscal/modeloDocFiscalService'
import TipoPessoaService from 'business/cadastro/pessoa/tipoPessoa/tipoPessoaService'
import CondicaoProdutoService from 'business/cadastro/produto/condicaoProduto/condicaoProdutoService'
import TipoProdutoService from 'business/cadastro/produto/tipoProduto/tipoProdutoService'
import MotivoDesoneraIcmsService from 'business/cadastro/fiscal/motivoDesoneraIcms/motivoDesoneraIcmsService'
import OrigemProdutoService from 'business/cadastro/produto/origemProduto/origemProdutoService'
import ListaNcmService from 'business/cadastro/fiscal/listaNcm/listaNcmService'
import TipoListaNcmService from 'business/cadastro/fiscal/tipoListaNcm/tipoListaNcmService'
import ListaCestNcmService from 'business/cadastro/fiscal/listaCestNcm/listaCestNcmService'
import TipoListaCestNcmService from 'business/cadastro/fiscal/tipoListaCestNcm/tipoListaCestNcmService'
import ListaMunicipioService from 'business/cadastro/fiscal/listaMunicipio/listaMunicipioService'
import ListaUfService from 'business/cadastro/fiscal/listaUf/listaUfService'
import CfopService from 'business/cadastro/fiscal/cfop/cfopService'
import RegimeBaseCalculoService from 'business/cadastro/fiscal/regimeBaseCalculo/regimeBaseCalculoService'
import FuncaoParticipanteService from 'business/cadastro/fiscal/funcaoParticipante/funcaoParticipanteService'
import TipoCalculoImpostoService from 'business/cadastro/fiscal/tipoCalculoImposto/tipoCalculoImpostoService'
import OperacaoService from 'business/cadastro/outros/operacao/operacaoService'
import MomentoService from 'business/cadastro/outros/momento/momentoService'
import ClassificacaoTributariaService from 'business/cadastro/fiscal/classificacaoTributaria/classificacaoTributariaService'
import TributoService from 'business/cadastro/fiscal/tributo/tributoService'
import EmpresaService from 'business/configuracao/empresa/empresaService'
import { Divider } from 'primereact/divider'
import OutputSpanForm from 'base/OutputSpanForm'
import ManualSnippet from 'base/ManualSnippet'
import Highlight from 'base/components/Highlight'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import { Dropdown } from 'primereact/dropdown'
import { confirmDialog } from 'primereact/confirmdialog'
import { InputSwitch } from 'primereact/inputswitch'

const tributoPossuiCampo = (tributo, campo) => {

    if (!tributo?.campos_opefis_tri) return false
    return tributo.campos_opefis_tri
        .split(',')
        .map(item => item.trim())
        .filter(Boolean)
        .includes(campo)
}

const operacaoFiscalAdOperacoes = [
    { codigo_ope: 'a', descricao_ope: 'Adicionar' },
    { codigo_ope: 'd', descricao_ope: 'Deduzir' }
]

const operacaoFiscalAdTiposValor = [
    { codigo_tiv: 'bc:v', descricao_tiv: 'Base de cálculo' },
    { codigo_tiv: 'v', descricao_tiv: 'Valor' }
]

export default function OperacaoFiscal() {

    const [service] = useState(() => new OperacaoFiscalService())
    const [regimeTributacaos, setRegimeTributacaos] = useState([])
    const [tipoOperacaoFiscals, setTipoOperacaoFiscals] = useState([])
    const [finalidadeOperacaoFiscals, setFinalidadeOperacaoFiscals] = useState([])
    const [ufs, setUfs] = useState([])
    const [municipios, setMunicipios] = useState([])
    const [series, setSeries] = useState([])
    const [modeloDocFiscals, setModeloDocFiscals] = useState([])
    const [tipoPessoas, setTipoPessoas] = useState([])
    const [condicaoProdutos, setCondicaoProdutos] = useState([])
    const [tipoProdutos, setTipoProdutos] = useState([])
    const [motivoDesoneraIcmss, setMotivoDesoneraIcmss] = useState([])
    const [origemProdutos, setOrigemProdutos] = useState([])
    const [listaNcms, setListaNcms] = useState([])
    const [tipoListaNcms, setTipoListaNcms] = useState([])
    const [listaCestNcms, setListaCestNcms] = useState([])
    const [tipoListaCestNcms, setTipoListaCestNcms] = useState([])
    const [listaMunicipios, setListaMunicipios] = useState([])
    const [listaUfs, setListaUfs] = useState([])
    const [cfops, setCfops] = useState([])
    const [regimeBaseCalculos, setRegimeBaseCalculos] = useState([])
    const [tipoCalculoImpostos, setTipoCalculoImpostos] = useState([])
    const [funcaoParticipantes, setFuncaoParticipantes] = useState([])
    const [classificacaoTributarias, setClassificacaoTributarias] = useState([])
    const [operacoes, setOperacoes] = useState([])
    const [momentos, setMomentos] = useState([])
    const [csts, setCsts] = useState(() => {
        const config = service.getCstConfig()
        return { optionKey: config.optionKey, optionLabel: config.optionLabel, options: [] }
    })
    const [tributos, setTributos] = useState([])
    useEffect(() => {
        tributosRef.current = tributos
    }, [tributos])
    const [empresas, setEmpresas] = useState([])
    const stepperRef = useRef(null)
    const toast = useRef(null)
    const location = useLocation()
    const { id } = useParams()
    const { pk } = location.state?.options ?? {}
    const hasId = Boolean(id)
    const [validations, setValidations] = useState(null)
    const schemaRef = useRef(null)
    const tributosRef = useRef([])

    const validationSchema = validations || yup.object()

    const form = useForm({
        defaultValues: async () => await load(),
        resolver: yupResolver(validationSchema),
        mode: "onBlur"
    })
    const operacaoFiscalAd = useFieldArray({
        control: form.control,
        name: 'operacao_fiscal_ad'
    })

    const selectedTributoCodigo = form.watch('cod_tri_opefis')
    const stCalc = form.watch('st_calc_opefis')
    const difalCalc = form.watch('difal_calc_opefis')
    const reteCalc = form.watch('rete_calc_opefis')
    const difeCalc = form.watch('dife_calc_opefis')
    const efetCalc = form.watch('efet_calc_opefis')
    const credOutCalc = form.watch('cred_out_calc_opefis')
    const formulasOpefis = form.watch('formulas_opefis')
    const tributoSelecionado = tributos.find(t => String(t.codigo_tri) === String(selectedTributoCodigo))
    const [showOperacaoFiscalAdAdd, setShowOperacaoFiscalAdAdd] = useState(false)
    const [showFormula, setShowFormula] = useState(false)
    const [newOperacaoFiscalAd, setNewOperacaoFiscalAd] = useState({ cod_ope_ofad: 'a', cod_tiv_ofad: 'bc:v' })

    const buildSchema = useCallback((schema) => {
        if (!schema) return schema
        const clonedSchema = schema?.clone ? schema.clone() : schema
        const shape = {}
        if (clonedSchema?.fields?.cod_cfop_opefis) {
            const cfopSchema = yup.object()
                .nullable()
                .test('cfop-valido', 'Inválido', value => !value || value?.codigo_cfop)
                .test('cfop-obrigatorio-tributo', 'Campo obrigatório para este tributo', function (value) {
                    const codTri = this.parent?.cod_tri_opefis
                    const tributo = tributosRef.current.find(t => String(t.codigo_tri) === String(codTri))
                    const requerCfop = tributoPossuiCampo(tributo, 'cod_cfop_opefis')
                    return !requerCfop || !!value
                })
            shape.cod_cfop_opefis = cfopSchema
        }
        if (clonedSchema?.fields?.cod_clastrib_opefis) {
            const clastribSchema = yup.object()
                .nullable()
                .test('clastrib-valido', 'Inválido', value => !value || value?.codigo_clastrib)
                .test('clastrib-obrigatorio-tributo', 'Campo obrigatório para este tributo', function (value) {
                    const codTri = this.parent?.cod_tri_opefis
                    const tributo = tributosRef.current.find(t => String(t.codigo_tri) === String(codTri))
                    const requerClastrib = tributoPossuiCampo(tributo, 'cod_clastrib_opefis')
                    return !requerClastrib || !!value
                })
            shape.cod_clastrib_opefis = clastribSchema
        }
        if (Object.keys(shape).length > 0) {
            return clonedSchema.shape(shape)
        }
        return clonedSchema
    }, [])

    const tributoPossuiCfop = tributoPossuiCampo(tributoSelecionado, 'cod_cfop_opefis')
    const tributoPossuiClastrib = tributoPossuiCampo(tributoSelecionado, 'cod_clastrib_opefis')
    const tributoPossuiStCalc = tributoPossuiCampo(tributoSelecionado, 'st_calc_opefis')
    const tributoPossuiDifalCalc = tributoPossuiCampo(tributoSelecionado, 'difal_calc_opefis')
    const tributoPossuiRetencaoCalc = tributoPossuiCampo(tributoSelecionado, 'rete_calc_opefis')
    const tributoPossuiDiferCalc = tributoPossuiCampo(tributoSelecionado, 'dife_calc_opefis')
    const tributoPossuiEfetCalc = tributoPossuiCampo(tributoSelecionado, 'efet_calc_opefis')
    const tributoPossuiCredOutCalc = tributoPossuiCampo(tributoSelecionado, 'cred_out_calc_opefis')

    useEffect(() => {
        if (!tributoPossuiCfop) {
            form.clearErrors('cod_cfop_opefis')
        }
    }, [tributoPossuiCfop, form])

    useEffect(() => {
        if (!tributoPossuiClastrib) {
            form.clearErrors('cod_clastrib_opefis')
        }
    }, [tributoPossuiClastrib, form])

    // MONTA A DESCRIÇÃO

    useEffect(() => {

        const updateDescription = (values) => {

            const novaDescricao = service.mountDescricao({ operacaoFiscal: values, tipoOperacaoFiscals, finalidadeOperacaoFiscals, ufs, series, motivoDesoneraIcmss, regimeTributacaos, listaMunicipios, listaUfs, listaCestNcms, tipoListaCestNcms, listaNcms, tipoListaNcms, regimeBaseCalculos })

            form.setValue('descricao_opefis', novaDescricao, { shouldDirty: true })
        }

        const subscription = form.watch((values, { name }) => {
            const fieldsToWatch = service.fieldsParaDescricao
            if (fieldsToWatch.includes(name)) {
                updateDescription(values)
            }
        })

        if (tipoOperacaoFiscals.length > 0) {
            const currentDesc = form.getValues('descricao_opefis')
            if (!currentDesc) {
                updateDescription(form.getValues())
            }
        }

        return () => subscription.unsubscribe() // Se não vai manter o watch em mémoria!

    }, [form, tipoOperacaoFiscals, finalidadeOperacaoFiscals, ufs, series, motivoDesoneraIcmss, regimeTributacaos, listaMunicipios, listaUfs, listaCestNcms, tipoListaCestNcms, listaNcms, tipoListaNcms, regimeBaseCalculos])

    async function load() {
        const data = await FormCadastroAux.load({ id: id || pk, service, toast, beforeSubmit, useNew: true })

        let regimes = []

        if (data?.tipo_operacao_fiscal) {
            setTipoOperacaoFiscals([createCodeDescriptionObject(data.tipo_operacao_fiscal, 'codigo_tiof', 'descricao_tiof', true)])
        }
        if (data?.finalidade_operacao_fiscal) {
            setFinalidadeOperacaoFiscals([createCodeDescriptionObject(data.finalidade_operacao_fiscal, 'codigo_fiof', 'descricao_fiof', true)])
        }
        if (data?.regime_tributacao_emp) {
            regimes.push(createCodeDescriptionObject(data.regime_tributacao_emp, 'codigo_regit', 'descricao_regit', true))
        }
        if (data?.regime_tributacao_e_emp) {
            regimes.push(createCodeDescriptionObject(data.regime_tributacao_e_emp, 'codigo_regit', 'descricao_regit', true))
        }
        if (data?.regime_tributacao_clifor) {
            regimes.push(createCodeDescriptionObject(data.regime_tributacao_clifor, 'codigo_regit', 'descricao_regit', true))
        }
        if (data?.regime_tributacao_e_clifor) {
            regimes.push(createCodeDescriptionObject(data.regime_tributacao_e_clifor, 'codigo_regit', 'descricao_regit', true))
        }

        if (regimes.length) setRegimeTributacaos(regimes)

        if (data?.uf) {
            setUfs([createCodeDescriptionObject(data.uf, 'codigo_uf', 'sigla_uf', false)])
        }
        if (data?.municipio) {
            data.cod_muni_clifor_opefis = createCodeDescriptionObject(data.municipio, 'codigo_muni', 'descricao_muni', false, ['uf.sigla_uf'])
            setMunicipios([data.cod_muni_clifor_opefis])
        }
        if (data?.serie) {
            setSeries([createCodeDescriptionObject(data.serie, 'codigo_serie', 'descricao_serie', false, ['sigla_serie'])])
        }
        if (data?.modelo_doc_fiscal) {
            setModeloDocFiscals([createCodeDescriptionObject(data.modelo_doc_fiscal, 'codigo_modf', 'descricao_modf', true)])
        }
        if (data?.tipo_pessoa) {
            setTipoPessoas([createCodeDescriptionObject(data.tipo_pessoa, 'codigo_tipe', 'descricao_tipe', false)])
        }
        if (data?.condicao_produto) {
            setCondicaoProdutos([createCodeDescriptionObject(data.condicao_produto, 'codigo_conp', 'descricao_conp', false)])
        }
        if (data?.tipo_produto) {
            setTipoProdutos([createCodeDescriptionObject(data.tipo_produto, 'codigo_tipp', 'descricao_tipp', true)])
        }
        if (data?.motivo_desonera_icms) {
            setMotivoDesoneraIcmss([createCodeDescriptionObject(data.motivo_desonera_icms, 'codigo_modi', 'descricao_modi', true, ['sigla_modi'])])
        }
        if (data?.origem_produto) {
            setOrigemProdutos([createCodeDescriptionObject(data.origem_produto, 'codigo_orip', 'descricao_orip', true)])
        }
        if (data?.lista_ncm) {
            setListaNcms([createCodeDescriptionObject(data.lista_ncm, 'codigo_linc', 'descricao_linc', true)])
        }
        if (data?.tipo_lista_ncm) {
            setTipoListaNcms([createCodeDescriptionObject(data.tipo_lista_ncm, 'codigo_tilin', 'descricao_tilin', false)])
        }
        if (data?.lista_cest_ncm) {
            setListaCestNcms([createCodeDescriptionObject(data.lista_cest_ncm, 'codigo_lcn', 'descricao_lcn', true)])
        }
        if (data?.tipo_lista_cest_ncm) {
            setTipoListaCestNcms([createCodeDescriptionObject(data.tipo_lista_cest_ncm, 'codigo_tlcn', 'descricao_tlcn', false)])
        }
        if (data?.lista_municipio) {
            setListaMunicipios([createCodeDescriptionObject(data.lista_municipio, 'codigo_limu', 'descricao_limu', true)])
        }
        if (data?.lista_uf) {
            setListaUfs([createCodeDescriptionObject(data.lista_uf, 'codigo_liuf', 'descricao_liuf', true)])
        }
        if (data?.cfop) {
            data.cod_cfop_opefis = createCodeDescriptionObject(data.cfop, 'codigo_cfop', 'descricao_cfop', true)
            setCfops([data.cod_cfop_opefis])
        }
        if (data?.classificacao_tributaria) {
            data.cod_clastrib_opefis = createCodeDescriptionObject(data.classificacao_tributaria, 'codigo_clastrib', 'descricao_clastrib', true)
            setClassificacaoTributarias([data.cod_clastrib_opefis])
        }
        if (data?.regime_base_calculo) {
            setRegimeBaseCalculos([createCodeDescriptionObject(data.regime_base_calculo, 'codigo_regbc', 'descricao_regbc', false)])
        }

        const tcis = []
        if (data?.tipo_calculo_imposto) {
            tcis.push(createCodeDescriptionObject(data.tipo_calculo_imposto, 'codigo_tci', 'descricao_tci'))
        }
        if (data?.difal_tipo_calculo_imposto) {
            tcis.push(createCodeDescriptionObject(data.difal_tipo_calculo_imposto, 'codigo_tci', 'descricao_tci'))
        }
        if (tcis.length) setTipoCalculoImpostos(tcis)

        const operacoesPreload = []
        if (data?.operacao_frete) {
            operacoesPreload.push(createCodeDescriptionObject(data.operacao_frete, 'codigo_ope', 'descricao_ope'))
        }
        if (data?.operacao_seguro) {
            operacoesPreload.push(createCodeDescriptionObject(data.operacao_seguro, 'codigo_ope', 'descricao_ope'))
        }
        if (data?.operacao_despesa) {
            operacoesPreload.push(createCodeDescriptionObject(data.operacao_despesa, 'codigo_ope', 'descricao_ope'))
        }
        if (data?.operacao_desconto) {
            operacoesPreload.push(createCodeDescriptionObject(data.operacao_desconto, 'codigo_ope', 'descricao_ope'))
        }
        if (data?.operacao_desoneracao) {
            operacoesPreload.push(createCodeDescriptionObject(data.operacao_desoneracao, 'codigo_ope', 'descricao_ope'))
        }
        if (data?.operacao_retencao) {
            operacoesPreload.push(createCodeDescriptionObject(data.operacao_retencao, 'codigo_ope', 'descricao_ope'))
        }
        if (operacoesPreload.length) {
            setOperacoes(operacoesPreload)
        }

        const funcaoParticipantesPreload = []
        if (data?.funcao_participante_difal) {
            funcaoParticipantesPreload.push(createCodeDescriptionObject(data.funcao_participante_difal, 'codigo_fupar', 'descricao_fupar'))
        }
        if (data?.funcao_participante_rete) {
            funcaoParticipantesPreload.push(createCodeDescriptionObject(data.funcao_participante_rete, 'codigo_fupar', 'descricao_fupar'))
        }
        if (funcaoParticipantesPreload.length) {
            setFuncaoParticipantes(funcaoParticipantesPreload)
        }

        if (data?.momento_reducao_bc) {
            setMomentos([createCodeDescriptionObject(data.momento_reducao_bc, 'codigo_mom', 'descricao_mom')])
        }
        const cstTable = data?.tributo?.cod_tabcst_tri ?? 'icms_cst'
        const cstConfig = service.getCstConfig(cstTable)
        setCsts(prev => ({
            ...prev,
            optionKey: cstConfig.optionKey,
            optionLabel: cstConfig.optionLabel
        }))
        const selectedCst = data?.[cstTable]
        if (selectedCst) {
            setCsts(prev => ({
                ...prev,
                options: [createCodeDescriptionObject(selectedCst, cstConfig.optionKey, cstConfig.optionLabel, true)]
            }))
        }
        if (data?.tributo || data?.operacao_fiscal_ad?.length) {
            const tributosPreload = []

            if (data?.tributo) {
                tributosPreload.push(service.setObjectTributo(data.tributo))
            }

            if (data?.operacao_fiscal_ad?.length) {
                data.operacao_fiscal_ad.forEach(item => {
                    if (!item?.tributo) return

                    const exists = tributosPreload.some(tributo => String(tributo.codigo_tri) === String(item.tributo.codigo_tri))
                    if (!exists) {
                        tributosPreload.push(service.setObjectTributo(item.tributo))
                    }
                })
            }

            if (tributosPreload.length) {
                setTributos(tributosPreload)
            }
        }
        if (data?.pessoa_emp) {
            setEmpresas([createCodeDescriptionObject(data.pessoa_emp, 'codigo_emp', 'nome_fantasia_pej', true, [], data.pessoa_emp.codigo_pej, data.pessoa_emp.nome_fantasia_pej)])
        }

        return data
    }

    const beforeSubmit = (data) => {
        let submitData = structuredClone(data)
        if (submitData.operacao_fiscal_ad) {
            service.formatActionOfArray(submitData.operacao_fiscal_ad, form.formState.dirtyFields.operacao_fiscal_ad)
        }
        submitData = service.prepareToSave({ data: submitData })
        return submitData
    }

    const addOperacaoFiscalAd = (event) => {
        event.preventDefault()

        operacaoFiscalAd.append(service.getNewOperacaoFiscalAd({
            cod_opefis_ofad: form.getValues('codigo_opefis') || null,
            cod_tri_ofad: selectedTributoCodigo || null,
            ...newOperacaoFiscalAd
        }))
        setNewOperacaoFiscalAd({ cod_ope_ofad: 'a', cod_tiv_ofad: 'bc:v' })
        setShowOperacaoFiscalAdAdd(false)
    }

    const removeOperacaoFiscalAd = (event, index) => {
        event.preventDefault()

        const atual = operacaoFiscalAd.fields[index]
        const tributo = tributos.find(item => String(item.codigo_tri) === String(form.getValues(`operacao_fiscal_ad.${index}.cod_tri_ofad`)))
        const nome = tributo?.descricao_tri || atual?.cod_tri_ofad || ''

        confirmDialog({
            message: 'Confirma remover? ' + nome,
            icon: 'pi pi-question-circle',
            accept: () => {
                const removeds = form.getValues('operacaoFiscalAdRemoved') || []
                if (atual?.codigo_ofad) {
                    removeds.push({ codigo_ofad: atual.codigo_ofad })
                    form.setValue('operacaoFiscalAdRemoved', removeds)
                }
                operacaoFiscalAd.remove(index)
            }
        })
    }

    useEffect(() => {
        let active = true
        service.getSchema().then(schema => {
            if (!active) return
            schemaRef.current = schema
            setValidations(buildSchema(schema))
        })
        return () => {
            active = false
        }
    }, [service, buildSchema])

    useEffect(() => {
        if (!schemaRef.current) return
        setValidations(buildSchema(schemaRef.current))
    }, [tributos, buildSchema])

    const loadRegimeTributacaos = async () => {
        const regit = new RegimeTributacaoService()
        await regit.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_regit', 'descricao_regit', true))
            options.push({ codigo_regit: null, descricao_regit: defaultEmptySelection() })
            setRegimeTributacaos(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadTipoOperacaoFiscals = async () => {
        const tiof = new TipoOperacaoFiscalService()
        await tiof.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_tiof', 'descricao_tiof', true))
            setTipoOperacaoFiscals(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadFinalidadeOperacaoFiscals = async () => {
        const fiof = new FinalidadeOperacaoFiscalService()
        await fiof.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_fiof', 'descricao_fiof', true))
            options.push({ codigo_fiof: null, descricao_fiof: defaultEmptySelection() })
            setFinalidadeOperacaoFiscals(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadOperacoes = async () => {
        const operacao = new OperacaoService()
        await operacao.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_ope', 'descricao_ope'))
            options.push({ codigo_ope: null, descricao_ope: defaultEmptySelection() })
            setOperacoes(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadMomentos = async () => {
        const momento = new MomentoService()
        await momento.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_mom', 'descricao_mom'))
            setMomentos(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadTipoCalculoImpostos = async () => {
        const tci = new TipoCalculoImpostoService()
        await tci.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_tci', 'descricao_tci'))
            setTipoCalculoImpostos(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadUfs = async () => {
        const uf = new UfService()
        await uf.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_uf', 'sigla_uf', false))
            options.push({ codigo_uf: null, sigla_uf: defaultEmptySelection() })
            setUfs(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadMunicipios = async (event) => {
        event.query = (event?.query ?? '').trim()
        if (!event.query) return
        const muni = new MunicipioService()
        await muni.listByAutoComplete(event.query).then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_muni', 'descricao_muni', false, ['meta.sigla_uf']))
            setMunicipios(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadListaUfs = async () => {
        const list = new ListaUfService()
        await list.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_liuf', 'descricao_liuf', true))
            options.push({ codigo_liuf: null, descricao_liuf: defaultEmptySelection() })
            setListaUfs(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadSeries = async () => {
        const serie = new SerieService()
        await serie.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_serie', 'descricao_serie', false, ['sigla_serie']))
            options.push({ codigo_serie: null, descricao_serie: defaultEmptySelection() })
            setSeries(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadModeloDocFiscals = async () => {
        const modf = new ModeloDocFiscalService()
        await modf.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_modf', 'descricao_modf', true))
            options.push({ codigo_modf: null, descricao_modf: defaultEmptySelection() })
            setModeloDocFiscals(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadTipoPessoas = async () => {
        const tipe = new TipoPessoaService()
        await tipe.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_tipe', 'descricao_tipe', false))
            options.push({ codigo_tipe: null, descricao_tipe: defaultEmptySelection() })
            setTipoPessoas(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadCondicaoProdutos = async () => {
        const conp = new CondicaoProdutoService()
        await conp.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_conp', 'descricao_conp', false))
            options.push({ codigo_conp: null, descricao_conp: defaultEmptySelection() })
            setCondicaoProdutos(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadTipoProdutos = async () => {
        const tipp = new TipoProdutoService()
        await tipp.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_tipp', 'descricao_tipp', true))
            options.push({ codigo_tipp: null, descricao_tipp: defaultEmptySelection() })
            setTipoProdutos(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadMotivoDesoneraIcmss = async () => {
        const modi = new MotivoDesoneraIcmsService()
        await modi.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_modi', 'descricao_modi', true, ['sigla_modi']))
            options.push({ codigo_modi: null, descricao_modi: defaultEmptySelection() })
            setMotivoDesoneraIcmss(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadOrigemProdutos = async () => {
        const orip = new OrigemProdutoService()
        await orip.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_orip', 'descricao_orip', true))
            options.push({ codigo_orip: null, descricao_orip: defaultEmptySelection() })
            setOrigemProdutos(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadListaNcms = async () => {
        const list = new ListaNcmService()
        await list.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_linc', 'descricao_linc', true))
            options.push({ codigo_linc: null, descricao_linc: defaultEmptySelection() })
            setListaNcms(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadListaCestNcms = async () => {
        const list = new ListaCestNcmService()
        await list.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_lcn', 'descricao_lcn', true))
            options.push({ codigo_lcn: null, descricao_lcn: defaultEmptySelection() })
            setListaCestNcms(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadTipoListaNcms = async () => {
        const list = new TipoListaNcmService()
        await list.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_tilin', 'descricao_tilin', false))
            options.push({ codigo_tilin: null, descricao_tilin: defaultEmptySelection() })
            setTipoListaNcms(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadTipoListaCestNcms = async () => {
        const list = new TipoListaCestNcmService()
        await list.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_tlcn', 'descricao_tlcn', false))
            options.push({ codigo_tlcn: null, descricao_tlcn: defaultEmptySelection() })
            setTipoListaCestNcms(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadListaMunicipios = async () => {
        const list = new ListaMunicipioService()
        await list.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_limu', 'descricao_limu', true))
            options.push({ codigo_limu: null, descricao_limu: defaultEmptySelection() })
            setListaMunicipios(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadCfops = async (event) => {
        event.query = (event?.query ?? '').trim()
        if (!event.query) return
        const cfop = new CfopService()
        await cfop.listByAutoComplete(event.query).then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_cfop', 'descricao_cfop', true))
            setCfops(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadClassificacaoTributarias = async (event) => {
        event.query = (event?.query ?? '').trim()
        if (!event.query) return
        const clastrib = new ClassificacaoTributariaService()
        await clastrib.listByAutoComplete(event.query).then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_clastrib', 'descricao_clastrib', true))
            setClassificacaoTributarias(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadRegimeBaseCalculos = async () => {
        const conp = new RegimeBaseCalculoService()
        await conp.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_regbc', 'descricao_regbc', false))
            options.push({ codigo_regbc: null, descricao_regbc: defaultEmptySelection() })
            setRegimeBaseCalculos(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadTabelaCsts = async () => {
        const codigoTabela = tributoSelecionado?.cod_tabcst_tri ?? 'icms_cst'
        await service.cstList(codigoTabela).then(({ list, optionKey, optionLabel }) => {
            const options = [...list, { [optionKey]: null, [optionLabel]: defaultEmptySelection() }]
            setCsts({
                optionKey,
                optionLabel,
                options
            })
        }).catch(err => errorToToast({ err, toast, alt: 'Não foi possível carregar os CSTs.' }))
    }
    const loadTributos = async () => {
        const tributoService = new TributoService()
        await tributoService.list('').then(rs => {
            const options = rs.data.data.map(e => service.setObjectTributo(e))
            setTributos(options)
        }).catch(err => errorToToast({ err, toast, alt: 'Não foi possível carregar os tributos.' }))
    }
    const loadEmpresas = async () => {
        const emp = new EmpresaService()
        await emp.listByAutoComplete().then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_emp', 'nome_fantasia_pej', true, [], e.codigo_emp, e.meta.nome_fantasia_pej))
            options.push({ codigo_emp: null, nome_fantasia_pej: defaultEmptySelection() })
            setEmpresas(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadFuncaoParticipantes = async () => {
        const funcaoParticipanteService = new FuncaoParticipanteService()
        await funcaoParticipanteService.list('').then(rs => {
            const allowed = []
            if (tributoSelecionado?.merc_tri) allowed.push('3', '4')
            else
                if (tributoSelecionado?.serv_tri) allowed.push('1', '2')

            const lista = rs.data.data.filter(item => {
                if (allowed.length === 0) return true
                return allowed.includes(String(item.codigo_fupar))
            })

            const options = lista.map(e => createCodeDescriptionObject(e, 'codigo_fupar', 'descricao_fupar', false))
            options.push({ codigo_fupar: null, descricao_fupar: defaultEmptySelection() })
            setFuncaoParticipantes(options)
        }).catch(err => errorToToast({ err, toast }))
    }
    useEffect(() => {
        loadTabelaCsts()
    }, [tributoSelecionado?.cod_tabcst_tri])

    return (
        < FormCadastro service={service} form={form} aux={FormCadastroAux} toast={toast} beforeSubmit={beforeSubmit}>
            <GridForm>
                <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_tri_opefis" form={form} type="dropdown2" service={service} label="Tributo"
                    optionKey='codigo_tri'
                    optionLabel='descricao_tri'
                    options={tributos}
                    onLoad={loadTributos}
                    disabled={hasId}
                />
                <ControllerInput addClassName="xl:col-8" field="descricao_opefis" form={form} service={service} type="text" clearString label="Descrição" />
            </GridForm>

            <TabView ref={stepperRef} className='text-sm mt-4' style={{ flexBasis: '1rem' }}>

                <TabPanel header="Operação" leftIcon="pi pi-home mr-2" >

                    <GridForm>

                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_tiof_opefis" form={form} type="dropdown2" service={service} label="Tipo de operação fiscal"
                            optionKey='codigo_tiof'
                            optionLabel='descricao_tiof'
                            options={tipoOperacaoFiscals}
                            onLoad={loadTipoOperacaoFiscals}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_fiof_opefis" form={form} type="dropdown2" service={service} label="Finalidade da operação"
                            optionKey='codigo_fiof'
                            optionLabel='descricao_fiof'
                            options={finalidadeOperacaoFiscals}
                            onLoad={loadFinalidadeOperacaoFiscals}
                        />

                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_conp_opefis" form={form} type="dropdown2" service={service} label="Condição do produto" optionKey='codigo_conp'
                            optionLabel='descricao_conp'
                            options={condicaoProdutos}
                            onLoad={loadCondicaoProdutos}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_orip_opefis" form={form} type="dropdown2" service={service} label="Origem"
                            optionKey='codigo_orip'
                            optionLabel='descricao_orip'
                            options={origemProdutos}
                            onLoad={loadOrigemProdutos}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_linc_opefis" form={form} type="dropdown2" service={service} label="Lista de NCM"
                            optionKey='codigo_linc'
                            optionLabel='descricao_linc'
                            options={listaNcms}
                            onLoad={loadListaNcms}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_tilin_opefis" form={form} type="dropdown2" service={service} label="Tipo de lista de NCM"
                            optionKey='codigo_tilin'
                            optionLabel='descricao_tilin'
                            options={tipoListaNcms}
                            onLoad={loadTipoListaNcms}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_tipp_opefis" form={form} type="dropdown2" service={service} label="Tipo de produto"
                            optionKey='codigo_tipp'
                            optionLabel='descricao_tipp'
                            options={tipoProdutos}
                            onLoad={loadTipoProdutos}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_modi_opefis" form={form} type="dropdown2" service={service} label="Motivo de desoneração do ICMS"
                            optionKey='codigo_modi'
                            optionLabel='descricao_modi'
                            options={motivoDesoneraIcmss}
                            onLoad={loadMotivoDesoneraIcmss}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_lcn_opefis" form={form} type="dropdown2" service={service} label="Lista de CEST/NCM"
                            optionKey='codigo_lcn'
                            optionLabel='descricao_lcn'
                            options={listaCestNcms}
                            onLoad={loadListaCestNcms}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_tlcn_opefis" form={form} type="dropdown2" service={service} label="Tipo de lista de CEST/NCM"
                            optionKey='codigo_tlcn'
                            optionLabel='descricao_tlcn'
                            options={tipoListaCestNcms}
                            onLoad={loadTipoListaCestNcms}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="eh_presencial_opefis" form={form} service={service} type="tristatecheckboxsimple" label="Operação presencial" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="eh_inventario_opefis" form={form} service={service} type="tristatecheckboxsimple" label="Inventário" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="eh_prod_defeito_opefis" form={form} service={service} type="tristatecheckboxsimple" label="Produto defeituoso" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="eh_emiss_propria_opefis" form={form} service={service} type="tristatecheckboxsimple" label="Emissão própria" />


                        <Divider className='my-4' align="center"><span className="text-sm font-bold p-2">Cliente / fornecedor</span></Divider>


                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_tipe_clifor_opefis" form={form} type="dropdown2" service={service} label="Pessoa física ou jurídica"
                            optionKey='codigo_tipe'
                            optionLabel='descricao_tipe'
                            options={tipoPessoas}
                            onLoad={loadTipoPessoas}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_limu_clifor_opefis" form={form} type="dropdown2" service={service} label="Na lista de cidades"
                            optionKey='codigo_limu'
                            optionLabel='descricao_limu'
                            options={listaMunicipios}
                            onLoad={loadListaMunicipios}
                        />
                        <ControllerInput addClassName="md:col-4 lg:col-3 xl:col-2"
                            form={form}
                            service={service}
                            type="autocomplete"
                            label="Cidade"
                            field='cod_muni_clifor_opefis'
                            suggestions={municipios}
                            completeMethod={loadMunicipios}
                            fieldShow={e => e.descricao_muni + ' - ' + e.sigla_uf}
                            itemTemplate={(item) => <span>{item.descricao_muni + ' - ' + item.sigla_uf}</span>}
                            placeholder='Digite a cidade'
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_liuf_clifor_opefis" form={form} type="dropdown2" service={service} label="Lista de UFs"
                            optionKey='codigo_liuf'
                            optionLabel='descricao_liuf'
                            options={listaUfs}
                            onLoad={loadListaUfs}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_uf_clifor_opefis" form={form} type="dropdown2" service={service} label="UF"
                            optionKey='codigo_uf'
                            optionLabel='sigla_uf'
                            options={ufs}
                            onLoad={loadUfs}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_regit_clifor_opefis" form={form} type="dropdown2" service={service} label="Regime"
                            optionKey='codigo_regit'
                            optionLabel='descricao_regit'
                            options={regimeTributacaos}
                            onLoad={loadRegimeTributacaos}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="eh_fora_pais_clifor_opefis" form={form} service={service} type="tristatecheckboxsimple" label="Fora do país" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="eh_fora_uf_clifor_opefis" form={form} service={service} type="tristatecheckboxsimple" label="Fora do estado" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="eh_fora_muni_clifor_opefis" form={form} service={service} type="tristatecheckboxsimple" label="Fora da cidade" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="eh_zfm_clifor_opefis" form={form} service={service} type="tristatecheckboxsimple" label="Zona franca de manaus" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="eh_contrib_icms_clifor_opefis" form={form} service={service} type="tristatecheckboxsimple" label="Contribuinte (ICMS)" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="mva_icms_esp_clifor_opefis" form={form} service={service} type="tristatecheckboxsimple" label="MVA-ICMS especial" />

                    </GridForm>

                </TabPanel>

                <TabPanel header="Mais" leftIcon="pi pi-home mr-2">
                    <GridForm>
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_emp_opefis" form={form} type="dropdown2" service={service} label="Empresa"
                            optionKey='codigo_emp'
                            optionLabel='nome_fantasia_pej'
                            options={empresas}
                            onLoad={loadEmpresas}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_regit_emp_opefis" form={form} type="dropdown2" service={service} label="Regime da empresa"
                            optionKey='codigo_regit'
                            optionLabel='descricao_regit'
                            options={regimeTributacaos}
                            onLoad={loadRegimeTributacaos}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_regite_emp_opefis" form={form} type="dropdown2" service={service} label="Regime especial da empresa"
                            optionKey='codigo_regit'
                            optionLabel='descricao_regit'
                            options={regimeTributacaos}
                            onLoad={loadRegimeTributacaos}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_regite_clifor_opefis" form={form} type="dropdown2" service={service} label="Regime especial do cli/for"
                            optionKey='codigo_regit'
                            optionLabel='descricao_regit'
                            options={regimeTributacaos}
                            onLoad={loadRegimeTributacaos}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_serie_opefis" form={form} type="dropdown2" service={service} label="Série"
                            optionKey='codigo_serie'
                            optionLabel='descricao_serie'
                            options={series}
                            onLoad={loadSeries}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_modf_opefis" form={form} type="dropdown2" service={service} label="Modelo de doc. fiscal"
                            optionKey='codigo_modf'
                            optionLabel='descricao_modf'
                            options={modeloDocFiscals}
                            onLoad={loadModeloDocFiscals}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-4" field="ncms_opefis" form={form} service={service} type="text" clearString label="NCMs (Ex: 87,4200)" rows={5} />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-4" field="cests_opefis" form={form} service={service} type="text" clearString label="CESTS (Ex: 87,4200)" rows={5} />

                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="ini_vig_opefis" form={form} service={service} type="calendar" label="Início da vigência" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="fim_vig_opefis" form={form} service={service} type="calendar" label="Fim da vigência" />
                    </GridForm>
                </TabPanel>

                <TabPanel header="Geral" leftIcon="pi pi-calculator mr-2">
                    <GridForm>
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-4" field="obs_nf_opefis" form={form} service={service} type="textarea" label="Observação na nota fiscal" rows={7} />
                        <Divider></Divider>

                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="obs_nf_fisco_opefis" form={form} service={service} type="switch" label="A obs é de interesse do fisco" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="obs_nf_imp_opefis" form={form} service={service} type="switch" label="Sempre impr. obs na NF" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="mov_estoque_opefis" form={form} service={service} type="switch" label="Movimenta estoque" />

                    </GridForm>
                </TabPanel>

                <TabPanel header={tributoSelecionado?.descricao_tri || 'Tributo'} leftIcon="pi pi-calculator mr-2">

                    <GridForm>

                        {tributoPossuiCfop && (
                            <ControllerInput addClassName="md:col-4 lg:col-3 xl:col-2"
                                form={form}
                                service={service}
                                type="autocomplete"
                                label="CFOP"
                                field='cod_cfop_opefis'
                                suggestions={cfops}
                                completeMethod={loadCfops}
                                fieldShow={e => e.descricao_cfop}
                                itemTemplate={(item) => <span>{item.descricao_cfop}</span>}
                                placeholder='Digite o CFOP'
                            />
                        )}

                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_cst_opefis" form={form} type="dropdown2" service={service} label="CST"
                            optionKey={csts.optionKey}
                            optionLabel={csts.optionLabel}
                            options={csts.options}
                            onLoad={loadTabelaCsts}
                        />
                        {tributoPossuiClastrib && (
                            <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-3"
                                form={form}
                                service={service}
                                type="autocomplete"
                                label="Classificação tributária"
                                field='cod_clastrib_opefis'
                                suggestions={classificacaoTributarias}
                                completeMethod={loadClassificacaoTributarias}
                                fieldShow={e => e.descricao_clastrib}
                                itemTemplate={(item) => <span>{item.descricao_clastrib}</span>}
                                placeholder='Digite a classificação'
                            />
                        )}
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="codigo_ben_fiscal_opefis" form={form} service={service} type="text" clearString label="Código do benefício fiscal" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_enquad_opefis" form={form} service={service} type="number" label="Código de enquadramento" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_regbc_opefis" form={form} type="dropdown2" service={service} label="Regime de BC"
                            optionKey='codigo_regbc'
                            optionLabel='descricao_regbc'
                            options={regimeBaseCalculos}
                            onLoad={loadRegimeBaseCalculos}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-2 xl:col-1" field="perc_bc_opefis" form={form} service={service} type="number" label="% BC" />
                        <ControllerInput addClassName="md:col-6 lg:col-2 xl:col-1" field="aliq_opefis" form={form} service={service} type="number" label="Alíquota" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_tci_opefis" form={form} type="dropdown2" service={service} label="Forma do cálculo"
                            optionKey='codigo_tci'
                            optionLabel='descricao_tci'
                            options={tipoCalculoImpostos}
                            onLoad={loadTipoCalculoImpostos}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cumul_opefis" form={form} service={service} type="switch" label="Cumulativo" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="envia_xml_nf_opefis" form={form} service={service} type="switch" label="Enviar no XML da NF" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="dir_cred_opefis" form={form} service={service} type="switch" label="Direito à crédito" />


                        <Divider className='my-4' align="center"><span className="text-sm font-bold">ADIÇÕES/DEDUÇÕES NA BC</span></Divider>

                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_ope_frete_opefis" form={form} type="dropdown2" service={service} label="Frete"
                            optionKey='codigo_ope'
                            optionLabel='descricao_ope'
                            options={operacoes}
                            onLoad={loadOperacoes}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_ope_seguro_opefis" form={form} type="dropdown2" service={service} label="Seguro"
                            optionKey='codigo_ope'
                            optionLabel='descricao_ope'
                            options={operacoes}
                            onLoad={loadOperacoes}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_ope_despesa_opefis" form={form} type="dropdown2" service={service} label="Despesas"
                            optionKey='codigo_ope'
                            optionLabel='descricao_ope'
                            options={operacoes}
                            onLoad={loadOperacoes}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_ope_deson_opefis" form={form} type="dropdown2" service={service} label="Desoneração"
                            optionKey='codigo_ope'
                            optionLabel='descricao_ope'
                            options={operacoes}
                            onLoad={loadOperacoes}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_ope_desc_opefis" form={form} type="dropdown2" service={service} label="Descontos"
                            optionKey='codigo_ope'
                            optionLabel='descricao_ope'
                            options={operacoes}
                            onLoad={loadOperacoes}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_ope_rete_opefis" form={form} type="dropdown2" service={service} label="Retenção"
                            optionKey='codigo_ope'
                            optionLabel='descricao_ope'
                            options={operacoes}
                            onLoad={loadOperacoes}
                        />

                        {operacaoFiscalAd.fields.map((item, index) => (
                            <div key={item.id} className="md:col-6 lg:col-4 xl:col-2 col-12 flex align-items-start gap-2">
                                <ControllerInput
                                    className="field flex-1"
                                    field={`operacao_fiscal_ad.${index}.cod_tri_ofad`}
                                    form={form}
                                    type="dropdown2"
                                    service={service}
                                    label={service.getLabelOfAdicionarTributo({ operacaoFiscalAd: item })}
                                    optionKey='codigo_tri'
                                    optionLabel='descricao_tri'
                                    options={tributos}
                                    onLoad={loadTributos}
                                />
                                <Button
                                    type="button"
                                    icon="pi pi-times"
                                    text
                                    severity="danger"
                                    size="small"
                                    className="mt-4"
                                    onClick={(event) => removeOperacaoFiscalAd(event, index)}
                                />
                            </div>
                        ))}
                        <div className="md:col-6 lg:col-4 xl:col-2 col-12 flex align-items-end mb-3">
                            <Button
                                type="button"
                                icon="pi pi-plus"
                                label="Adicionar"
                                severity="success"
                                size="small"
                                onClick={(event) => {
                                    event.preventDefault()
                                    setShowOperacaoFiscalAdAdd(true)
                                }}
                            />
                        </div>
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_mom_red_bc_opefis" form={form} type="dropdown2" service={service} label="Reduzir a BC A/D das ad/deduções"
                            optionKey='codigo_mom'
                            optionLabel='descricao_mom'
                            options={momentos}
                            onLoad={loadMomentos}
                        />
                        <div className="field col-12 md:col-6 lg:col-4 xl:col-2 mb-2">
                            <label htmlFor="showFormula" className="mb-1 text-sm">Fórmula</label>
                            <div className="flex flex-row">
                                <InputSwitch inputId="showFormula" checked={showFormula} onChange={(event) => setShowFormula(event.value)} />
                            </div>
                        </div>
                        {showFormula && <div className="field col-12 mb-2">
                            <div className='mb-2 border-1 py-2 px-4'>
                                <Highlight value={formulasOpefis} />
                            </div>
                        </div>}

                        {(tributoPossuiStCalc
                            || tributoPossuiDifalCalc
                            || tributoPossuiRetencaoCalc
                            || tributoPossuiDiferCalc
                            || tributoPossuiEfetCalc
                            || tributoPossuiCredOutCalc) &&
                            <Divider className='my-4' align="center"><span className="text-sm font-bold">OPÇÕES</span></Divider>
                        }

                        {tributoPossuiStCalc && (<ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="st_calc_opefis" form={form} service={service} type="switch" label="Calcular ST" />)}
                        {tributoPossuiDifalCalc && (<ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="difal_calc_opefis" form={form} service={service} type="switch" label="Calcular difal" />)}
                        {tributoPossuiRetencaoCalc && (<ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="rete_calc_opefis" form={form} service={service} type="switch" label="Calcular retenção" />)}
                        {tributoPossuiDiferCalc && (<ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="dife_calc_opefis" form={form} service={service} type="switch" label="Calcular diferimento" />)}
                        {tributoPossuiEfetCalc && (<ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="efet_calc_opefis" form={form} service={service} type="switch" label="Calcular imposto efetivo" />)}
                        {tributoPossuiCredOutCalc && (<ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cred_out_calc_opefis" form={form} service={service} type="switch" label="Calcular crédito outorgado" />)}

                    </GridForm>

                </TabPanel>


                {stCalc && (
                    <TabPanel header="ST" leftIcon="pi pi-calculator mr-2" >
                        <GridForm>

                            <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="st_mva_opefis" form={form} service={service} type="number" label="% MVA" />
                            <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="st_perc_bc_opefis" form={form} service={service} type="number" label="% de base de cálculo" />
                            <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="st_aliq_opefis" form={form} service={service} type="number" label="Alíquota" />
                            <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="st_ret_calc_opefis" form={form} service={service} type="switch" label="Calcular retenção de ST" />

                        </GridForm>
                    </TabPanel>
                )}
                {difalCalc && (
                    <TabPanel header="DIFAL" leftIcon="pi pi-calculator mr-2" >
                        <GridForm>
                            <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="difal_aliq_int_dest_opefis" form={form} service={service} type="number" label="Alíquota interna destino" />
                            <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="difal_aliq_interest_opefis" form={form} service={service} type="number" label="Alíquota interestadual" />
                            <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="difal_cod_tci_opefis" form={form} type="dropdown2" service={service} label="Forma do cálculo"
                                optionKey='codigo_tci'
                                optionLabel='descricao_tci'
                                options={tipoCalculoImpostos}
                                onLoad={loadTipoCalculoImpostos}
                            />
                            <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="difal_cod_fupar_rec_opefis" form={form} type="dropdown2" service={service} label="Responsável por recolher"
                                optionKey='codigo_fupar'
                                optionLabel='descricao_fupar'
                                options={funcaoParticipantes}
                                onLoad={loadFuncaoParticipantes}
                            />
                            <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="difal_bc_desc_opefis" form={form} service={service} type="switch" label="Aplicar desconto na BC" />
                            <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="difal_bc_fsd_opefis" form={form} service={service} type="switch" label="Somar frete/seguro/despesa na BC" />
                        </GridForm>
                    </TabPanel>
                )}
                {(reteCalc) && (
                    <TabPanel header="RETENÇÃO" leftIcon="pi pi-calculator mr-2" >
                        <GridForm>
                            <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="rete_perc_bc_opefis" form={form} service={service} type="number" label="% de base de cálculo" />
                            <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="rete_aliq_opefis" form={form} service={service} type="number" label="Alíquota" />
                            <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="rete_vlr_min_opefis" form={form} service={service} type="number" label="Valor mínimo para retenção" />
                            <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="rete_cod_fupar_opefis" form={form} type="dropdown2" service={service} label="Retido por"
                                optionKey='codigo_fupar'
                                optionLabel='descricao_fupar'
                                options={funcaoParticipantes}
                                onLoad={loadFuncaoParticipantes}
                            />

                        </GridForm>
                    </TabPanel>
                )}
                {(difeCalc) && (
                    <TabPanel header="DIFERIMENTO" leftIcon="pi pi-calculator mr-2" >
                        <GridForm>
                            <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="dife_aliq_opefis" form={form} service={service} type="number" label="Alíquota" />
                        </GridForm>
                    </TabPanel>
                )}
                {(credOutCalc) && (
                    <TabPanel header="CR. OUTORGADO" leftIcon="pi pi-calculator mr-2" >
                        <GridForm>
                            <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cred_out_perc_bc_opefis" form={form} service={service} type="number" label="% de base de cálculo" />
                            <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cred_out_aliq_opefis" form={form} service={service} type="number" label="Alíquota" />
                        </GridForm>
                    </TabPanel>
                )}
                <TabPanel header="Info" leftIcon="pi pi-info-circle mr-2" visible={id > 0}>

                    <GridForm>
                        <ControllerInput addClassName="md:col-4 lg:col-4 xl:col-3 mb-2" field="edita_opefis" form={form} service={service} type="switch" label="Editável" disabled={true} />
                        <OutputSpanForm field="emp_ins_opefis" className="col-12 md:col-4 lg:col-4 xl:col-3 mb-2" value={cd({ code: form.getValues('emp_ins_opefis'), description: form.getValues('meta.empresa_ins_nome') })} label="Na empresa" />
                        <OutputSpanForm field="usu_ins_opefis" className="col-12 md:col-4 lg:col-4 xl:col-3 mb-2" value={cd({ code: form.getValues('usu_ins_opefis'), description: form.getValues('meta.usuario_ins_nome') })} label="Inserção" />
                        <OutputSpanForm field="usu_atua_opefis" className="col-12 md:col-4 lg:col-4 xl:col-3 mb-2" value={cd({ code: form.getValues('usu_atua_opefis'), description: form.getValues('meta.usuario_atua_nome') })} label="Atualização" />
                        <OutputSpanForm field="dh_ins_opefis" className="col-12 md:col-4 lg:col-4 xl:col-3 mb-2" form={form} value={formatDatetime(form.getValues('dh_ins_opefis'))} label="Inserção" />
                        <OutputSpanForm field="dh_atua_opefis" className="col-12 md:col-4 lg:col-4 xl:col-3 mb-2" form={form} value={formatDatetime(form.getValues('dh_atua_opefis'))} label="Atualização" />
                    </GridForm>

                </TabPanel>

            </TabView >
            <Divider></Divider>
            <Dialog
                header="Adicionar"
                visible={showOperacaoFiscalAdAdd}
                style={{ width: '28rem' }}
                modal
                onHide={() => setShowOperacaoFiscalAdAdd(false)}
                footer={
                    <div className="flex justify-content-end gap-2">
                        <Button type="button" label="Cancelar" text size="small" onClick={() => setShowOperacaoFiscalAdAdd(false)} />
                        <Button type="button" label="Confirmar" icon="pi pi-check" size="small" onClick={addOperacaoFiscalAd} />
                    </div>
                }
            >
                <div className="formgrid grid p-fluid">
                    <div className="field col-12">
                        <label className="text-sm">Operação</label>
                        <Dropdown
                            className="p-inputtext-sm mt-1"
                            value={newOperacaoFiscalAd.cod_ope_ofad}
                            options={operacaoFiscalAdOperacoes}
                            optionValue="codigo_ope"
                            optionLabel="descricao_ope"
                            onChange={(event) => setNewOperacaoFiscalAd(prev => ({ ...prev, cod_ope_ofad: event.value }))}
                        />
                    </div>
                    <div className="field col-12">
                        <label className="text-sm">Tipo de valor</label>
                        <Dropdown
                            className="p-inputtext-sm mt-1"
                            value={newOperacaoFiscalAd.cod_tiv_ofad}
                            options={operacaoFiscalAdTiposValor}
                            optionValue="codigo_tiv"
                            optionLabel="descricao_tiv"
                            onChange={(event) => setNewOperacaoFiscalAd(prev => ({ ...prev, cod_tiv_ofad: event.value }))}
                        />
                    </div>
                </div>
            </Dialog>
            <ManualSnippet
                className='text-sm p-0 font-italic xl:col-5'
                file='cadastro_fiscal_operacao_fiscal.md'
                exportId='operacao-fiscal.icms.fill'
            />
        </FormCadastro >
    )
}
